import { Controller } from '@hotwired/stimulus'

// Makes ActiveAdmin form sections (fieldsets with a legend, panels and
// has-many containers with a heading) collapsible by clicking their title.
// Sections start collapsed on edit forms only — detected through the hidden
// `_method=patch` input — so the "new" form keeps its current behavior.
// Sections containing validation errors stay expanded so errors remain
// visible after a failed save.
export default class extends Controller {
  connect () {
    const startCollapsed = !!this.element.querySelector('input[name="_method"][value="patch"]')

    this.sections().forEach((section) => {
      const header = section.querySelector(':scope > legend, :scope > h3')
      if (!header) return

      header.classList.add('aa-collapsible-header')
      header.setAttribute('role', 'button')
      header.setAttribute('tabindex', '0')
      header.addEventListener('click', () => this.toggle(section))
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return

        event.preventDefault()
        this.toggle(section)
      })

      const hasErrors = !!section.querySelector('.inline-errors, .error')
      this.setCollapsed(section, startCollapsed && !hasErrors)
    })
  }

  sections () {
    return this.element.querySelectorAll('fieldset.inputs, .panel, .has_many_container')
  }

  toggle (section) {
    this.setCollapsed(section, !section.classList.contains('aa-collapsed'))
  }

  setCollapsed (section, collapsed) {
    section.classList.toggle('aa-collapsed', collapsed)
    section.querySelector(':scope > .aa-collapsible-header')
      ?.setAttribute('aria-expanded', String(!collapsed))
  }
}
